<template>
    <div class="app_introduce">
        <!-- <moe-top></moe-top> -->
        <div class="introduce_one">
        </div>
        <div class="introduce_one introduce_two">
            <div class="two_title">推广员</div>
            <div class="two_desc">
                推广后实时追踪佣金收益，订单完成后支持一键提现，保障资金流转高效透明。
                支持联盟成员审核、推广员管理、分销佣金自定义配置等管理工具，满足差异化运营需求。
            </div>
        </div>
        <div class="introduce_one introduce_three">

        </div>
        <div class="introduce_one introduce_four">

        </div>

        <moe-bottom></moe-bottom>
    </div>
</template>

<script>
export default {
    name: "GjkcH5Index",

    data() {
        return {};
    },

    mounted() { },

    methods: {},
};
</script>

<style lang="scss" scoped>
.app_introduce {
    width: 100%;

    .introduce_one {
        box-sizing: border-box;
        width: 100%;
        height: 760px;
        background-image: url("/public/static/img/alliance_distribution_bg1.png");
        background-size: cover;

        .one_content {
            .one_top {
                padding-left: 930px;
                padding-top: 190px;

                .app_logo {
                    width: 118px;
                    height: 118px;
                    border-radius: 10px;
                }

                .one_title {
                    font-weight: 600;
                    font-size: 36px;
                    color: #333333;
                    line-height: 50px;
                }

                .one_subtitle {
                    font-size: 20px;
                    color: #606060;
                    line-height: 28px;
                }
            }

            .one_desc {
                padding-left: 930px;
                padding-top: 15px;
                font-weight: 500;
                width: 625px;
                height: 225px;
                line-height: 45px;
                color: #303030;
                font-size: 24px;
            }
        }
    }

    .introduce_two {
        background-image: url("/public/static/img/alliance_distribution_bg2.png");

        .two_title {
            font-weight: 600;
            font-size: 63px;
            color: #333333;
            line-height: 88px;
            padding-top: 40px;
            padding-left: 830px;
        }

        .two_desc {
            padding-top: 20px;
            padding-left: 530px;
            width: 920px;
            height: 84px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 500;
            font-size: 24px;
            color: #303030;
            line-height: 42px;
            text-align: center;
        }
    }

    .introduce_three {
        background-image: url("/public/static/img/alliance_distribution_bg3.png");

        .three_title {
            padding-top: 234px;
            padding-left: 955px;
            font-weight: 600;
            font-size: 63px;
            color: #333333;
            line-height: 88px;
        }

        .three_desc {
            width: 559px;
            height: 126px;
            padding-top: 30px;
            padding-left: 955px;
            font-weight: 500;
            font-size: 24px;
            color: #303030;
            line-height: 42px;
        }
    }

    .introduce_four {
        background-image: url("/public/static/img/alliance_distribution_bg4.png");

        .four_title {
            padding-top: 237px;
            padding-left: 410px;
            font-weight: 600;
            font-size: 63px;
            color: #333333;
            line-height: 88px;
        }

        .four_desc {
            width: 531px;
            height: 168px;
            padding-top: 45px;
            padding-left: 410px;
            font-size: 26px;
            color: #303030;
            line-height: 42px;
            line-height: 42px;
        }
    }
}
</style>